import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=5bad1d88&scoped=true&"
import script from "./recommend.vue?vue&type=script&lang=ts&"
export * from "./recommend.vue?vue&type=script&lang=ts&"
import style0 from "./recommend.vue?vue&type=style&index=0&id=5bad1d88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bad1d88",
  null
  
)

export default component.exports